import { isEmpty } from 'lodash';
import { useEffect } from 'react';
import Config from '@gral/config';
import { LoginForm, Grid, Logo } from '@ts/storybook';

import { loginWithCredentials, redirectToMSA } from '@services/ApiService';
import { useAppDispatch, useAppSelector } from '@redux/store';
import { ELoginState } from '@interfaces/App.interface';
import { useRouterContext } from '@utils/context/RouterContext';
import { appPalette } from '@public/customization/CustomTheme';

const LoginPage = () => {
  const dispatch = useAppDispatch();
  const { navigate, location } = useRouterContext();

  const logo = require(`@public/assets/logo/${Config.getLogo()}`);

  const sessionBadge = useAppSelector(state => state.global.sessionBadge);
  const loginState = useAppSelector(state => state.global.loginState);
  const isLoggedIn = loginState === ELoginState.LOGGED_IN;

  const onSubmit = ({ login, password }) => {
    if (isEmpty(login) || isEmpty(password)) {
      return;
    }
    loginWithCredentials(dispatch, { login, password });
  };
  //#endregion

  useEffect(() => {
    if (isLoggedIn && sessionBadge) {
      let nextRoute = '/';
      navigate(nextRoute, { state: { resetHistoryLevel: 0 } });
    }
  }, [location]);

  if (isLoggedIn && sessionBadge) return;

  return (
    <Grid
      id="loginContainer"
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      size={12}
      sx={{ height: '100vh', backgroundColor: appPalette.primary }}
    >
      <Grid size={'auto'}>
        <div style={{ width: '80%', maxWidth: '350px', margin: 'auto' }}>
          <Logo caption="logo" src={logo} width={410} height={107} id="logo_img" />
        </div>
        <LoginForm
          onSubmit={onSubmit}
          onSubmitMSA={() => {
            redirectToMSA();
          }}
          onClickResetPassword={() => {
            navigate('/forgot_password');
          }}
        />
      </Grid>
    </Grid>
  );
};

export default LoginPage;
